import React from 'react'
import Select from 'react-select'
import { ajaxGet } from '../ajax'
import { PhoneInput } from 'react-international-phone'

class PlayerSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isNew: false,
      phoneNumber: '',
      countryCode: ''
    }
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.renderSelect = this.renderSelect.bind(this)
    this.creatableSelect = this.creatableSelect.bind(this)
    this.usualSelect = this.usualSelect.bind(this)
    this.loadPlayers = input => {
      if (!input || input.length < 3) return Promise.resolve({options: []})

      const params = this.searchParams(input)
      return ajaxGet(`/admins/clients.json?` + new URLSearchParams(params))
        .then(response => response.json())
        .then(json => ({options: json.users.map(user => ({value: user.id, label: user.text}))}))
    }
    props.refresh && props.refresh(this.refreshPlayer.bind(this))
  }

  searchParams(input) {
    var params = { q: input }
    if (this.props.reservationId) params['reservation_id'] = this.props.reservationId
    return params
  }

  refreshPlayer() {
    this.setState({isNew: false, selectedPlayer: null})
  }

  creatableSelect() {
    const props = this.props

    return <Select.AsyncCreatable
      isValidNewOption={data => data.label && (data.label.length >= 3)}
      loadOptions={this.loadPlayers}
      name={props.formName ? `${props.formName}[${props.playerIdFieldName}]` : 'firstName'}
      onChange={this.handleSelectChange}
      placeholder='Select a client'
      autoBlur
      filterOption={() => true}
      promptTextCreator={text => text.length >= 3 ? `+ New Client "${text}"` : ''}
      value={this.state.selectedPlayer}
      searchPromptText='Please enter 3 or more characters'
      onCloseResetsInput={false}
      onBlurResetsInput={false}
    />
  }

  usualSelect() {
    return <Select.Async
      autoBlur
      placeholder='Select a player'
      searchPromptText='Please enter 3 or more characters'
      value={this.state.selectedPlayer}
      onChange={this.handleSelectChange}
      loadOptions={this.loadPlayers}
      filterOption={() => true}
      onCloseResetsInput={false}
      onBlurResetsInput={false}
    />
  }

  renderSelect() {
    return this.props.disableNewOption ? this.usualSelect() : this.creatableSelect()
  }

  handleSelectChange(selectedPlayer) {
    this.setState({selectedPlayer: selectedPlayer})
    if (!selectedPlayer) {
      this.setState({isNew: false})
      this.props.onChange({id: null})
    } else if (selectedPlayer.value === selectedPlayer.label) {
      this.setState({firstName: selectedPlayer.value, isNew: true});
      this.props.onChange({id: null, firstName: selectedPlayer.label});
    } else {
      this.setState({isNew: false});
      this.props.onChange({id: selectedPlayer.value});
    }
  }

  render() {
    const props = this.props
    return (
      <div className='player-selector' ref={e => this.domElement = e}>
        {!this.state.isNew &&
          <div className='player-selector__select'>
            { this.renderSelect() }
            <div className='error_container' data-target={props.playerIdFieldName} />
          </div>
        }
        {this.state.isNew &&
          <div className='player-selector__input'>
            <input className='form-control' placeholder='First Name'
              defaultValue={this.state.firstName}
              name={props.formName ? `${props.formName}[${props.firstNameFieldName}]` : null}
              onChange={e => this.props.onChange({firstName: e.target.value})} />
            <div className='error_container' data-target={props.firstNameFieldName} />
          </div>
        }
        {this.state.isNew &&
          <div className='player-selector__input'>
            <input className='form-control' placeholder='Last Name'
              name={props.formName ? `${props.formName}[${props.lastNameFieldName}]` : null}
              onChange={(e) => this.props.onChange({lastName: e.target.value})} />
            <div className='error_container' data-target={props.lastNameFieldName} />
          </div>
        }
        {this.state.isNew &&
          <div className='player-selector__input flag-hidden'>
            <PhoneInput
              defaultCountry='US'
              placeholder='Phone Number'
              inputClassName='form-control'
              inputProps={{
                name: props.formName ? `${props.formName}[${props.phoneNumberFieldName}]` : null
              }}
              value={this.state.phoneNumber}
              onChange={(phone, country) => {
                this.setState({countryCode: country, phoneNumber: phone})
                this.props.onChange({countryCode: country, phoneNumber: phone})
              }} />
          </div>
        }
        {this.state.isNew &&
          <div className='player-selector__input'>
            <input className='form-control' type='email' placeholder='Email'
              name={props.formName ? `${props.formName}[${props.emailFieldName}]` : null}
              onChange={(e) => this.props.onChange({email: e.target.value})} />
            <div className='error_container' data-target={props.emailFieldName} />
          </div>
        }
        {this.state.isNew &&
          <input value='true' type='hidden' name={`${props.formName}[new_player]`} />
        }
      </div>
    )
  }
}

export default PlayerSelector
